import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {
  Box,
  TextField,
  MenuItem,
  Select,
  FormHelperText,
  InputLabel,
  FormControl,
  Button,
  Typography,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  InputAdornment,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useDispatch } from "react-redux";
import { UpdateUserAccountSlice } from "../../redux/slices/createUserAccount";

// Yup schema
const schema = yup.object().shape({
  name: yup.string().required("User Name is required"),
  // password: yup
  //   .string()
  //   .min(6, "Password must be at least 6 characters")
  //   .required("Password is required"),
  role: yup.string().required("Role is required"),
  shift: yup.string().required("Shift is required"),
});

const UserFormEdit = ({ open, onClose, previousData = {} }) => {
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      password: "",
    },
  });

  const onSubmit = (data) => {
    const finalData = {
      ...data,
      id: previousData?._id || "",
      email: previousData?.email || "",
    };
    dispatch(UpdateUserAccountSlice(finalData));
    onClose(); // Close the dialog after submission
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { borderRadius: 3, p: 1 } }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 2,
        }}
      >
        <DialogTitle sx={{ fontWeight: 600, flexGrow: 1, p: 0 }}>
          Edit User
        </DialogTitle>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent sx={{ width: 420, pt: 1 }}>
        <Box
          component="form"
          onSubmit={handleSubmit(onSubmit)}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            mt: 1,
          }}
        >
          <Stack direction="column" gap={1}>
            <Typography fontWeight={500}>User Name</Typography>
            <TextField
              size="small"
              placeholder="Enter user name"
              {...register("name")}
              defaultValue={previousData.name || ""}
              error={!!errors.name}
              helperText={errors.name?.message}
            />
          </Stack>

          <Stack direction="column" gap={1}>
            <Typography fontWeight={500}>Email</Typography>
            <TextField size="small" disabled value={previousData.email || ""} />
          </Stack>

          <Stack direction="column" gap={1}>
            <Typography fontWeight={500}>Password</Typography>
            <TextField
              size="small"
              type={showPassword ? "text" : "password"}
              placeholder="Enter new password"
              {...register("password")}
              error={!!errors.password}
              helperText={errors.password?.message}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                      size="small"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Stack>

          <Stack direction="column" gap={1}>
            <Typography fontWeight={500}>Role</Typography>
            <FormControl size="small" error={!!errors.role} fullWidth>
              <Select defaultValue={previousData?.role} {...register("role")}>
                <MenuItem value="admin">Admin</MenuItem>
                <MenuItem value="manager">Manager</MenuItem>
                <MenuItem value="designer">Designer</MenuItem>
                <MenuItem value="redeem_agent">Redeem Agent</MenuItem>
                <MenuItem value="deposit_agent">Deposit Agent</MenuItem>
              </Select>
              <FormHelperText>{errors.role?.message}</FormHelperText>
            </FormControl>
          </Stack>

          <Stack direction="column" gap={1}>
            <Typography fontWeight={500}>Shift</Typography>
            <TextField
              size="small"
              placeholder="Morning, Evening, Night"
              {...register("shift")}
              defaultValue={previousData?.shift || ""}
              error={!!errors.shift}
              helperText={errors?.shift?.message}
            />
          </Stack>

          <Button type="submit" variant="contained" fullWidth sx={{ mt: 2 }}>
            Update User
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default UserFormEdit;
